export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading text-accent-400 whitespace-nowrap">
              黑料718
            </span>
            <p className="text-sm text-background-400 leading-relaxed mt-3">
              黑料718官网为您提供黑料718网址、黑料718入口直达服务，一站式获取最新黑料吃瓜内容。百万吃瓜群众的首选入口。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">首页</a>
              <a href="#index" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">热门专题</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">最新快讯</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">深度爆料</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">常见问答</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">热门话题</h4>
            <nav className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">明星恋情</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">税务风波</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">选秀内幕</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">网红塌房</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">品牌解约</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              诚邀优质内容平台与媒体机构加入合作，共同打造健康、有趣的吃瓜内容生态。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 max-w-6xl mx-auto">
          <p className="text-xs text-background-500">
            &copy; 2026 黑料718. 本站为品牌展示页面，仅供访问入口引导使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>黑料718网址</span>
            <span>黑料718官网</span>
            <span>黑料718入口</span>
          </div>
        </div>
      </div>
    </footer>
  );
}